/* eslint-disable max-classes-per-file */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  AlertTitle,
  Container,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import errorLogService from 'src/utils/errorLogService';
import config from 'src/config';

const { errorMessage } = config;

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    const { location } = this.props;
    const metadata =
      location &&
      JSON.stringify({
        router: {
          state: location.state
        }
      });

    this.setState({
      errorInfo
    });

    errorLogService(error, errorInfo.componentStack, metadata);
  }

  render() {
    const { errorInfo } = this.state;
    const { children } = this.props;

    if (errorInfo) {
      // Error path
      return (
        <Container>
          <Box mt={5}>
            <Alert severity="error">
              <AlertTitle>Something went wrong.</AlertTitle>
              {errorMessage}
            </Alert>
          </Box>
        </Container>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object
};

export class ErrorBoundaryModal extends Component {
  constructor(props) {
    super(props);
    this.state = { errorInfo: null };
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidCatch(error, errorInfo) {
    const { location } = this.props;
    const metadata =
      location &&
      JSON.stringify({
        router: {
          state: location.state
        }
      });
    this.setState({
      errorInfo
    });

    errorLogService(error, errorInfo.componentStack, metadata);
  }

  handleClose() {
    this.setState({
      errorInfo: null
    });
  }

  render() {
    const { errorInfo } = this.state;
    const { children } = this.props;

    if (errorInfo) {
      return (
        <Dialog
          open={!!errorInfo}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" variant="h4" component="h1">
            Something went wrong.
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {errorMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Got it
            </Button>
          </DialogActions>
        </Dialog>
      );
    }

    return children;
  }
}

ErrorBoundaryModal.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object
};
